(function () {
  'use strict';

  /* ── Mobile nav ─────────────────────────────────────────── */
  function initMobileNav() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    var iconOpen = toggle.querySelector('[data-menu-icon-open]');
    var iconClose = toggle.querySelector('[data-menu-icon-close]');

    function setOpen(open) {
      menu.classList.toggle('hidden', !open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      if (iconOpen) iconOpen.classList.toggle('hidden', open);
      if (iconClose) iconClose.classList.toggle('hidden', !open);
    }

    toggle.addEventListener('click', function () {
      setOpen(menu.classList.contains('hidden'));
    });

    menu.addEventListener('click', function (e) {
      if (e.target === menu) setOpen(false);
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 768) setOpen(false);
    });
  }

  /* ── FAQ accordion ──────────────────────────────────────── */
  function initFaq() {
    document.querySelectorAll('[data-faq]').forEach(function (root) {
      root.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('[data-faq-item]');
          if (!item) return;
          var panel = item.querySelector('[data-faq-panel]');
          var open = btn.getAttribute('aria-expanded') === 'true';
          var next = !open;

          // Close siblings in home FAQ (plus/minus style)
          root.querySelectorAll('[data-faq-item]').forEach(function (sib) {
            if (sib === item) return;
            var sBtn = sib.querySelector('[data-faq-toggle]');
            var sPanel = sib.querySelector('[data-faq-panel]');
            var sPlus = sib.querySelector('[data-faq-icon-plus]');
            var sMinus = sib.querySelector('[data-faq-icon-minus]');
            if (sBtn) sBtn.setAttribute('aria-expanded', 'false');
            if (sPanel) sPanel.classList.add('hidden');
            if (sPlus) sPlus.classList.remove('hidden');
            if (sMinus) sMinus.classList.add('hidden');
          });

          btn.setAttribute('aria-expanded', next ? 'true' : 'false');
          if (panel) panel.classList.toggle('hidden', !next);
          var plus = item.querySelector('[data-faq-icon-plus]');
          var minus = item.querySelector('[data-faq-icon-minus]');
          if (plus) plus.classList.toggle('hidden', next);
          if (minus) minus.classList.toggle('hidden', !next);
        });
      });
    });
  }

  /* ── Reviews infinite scroller + full-review modal ─────── */
  function initReviews() {
    var root = document.querySelector('[data-reviews]');
    var el = document.querySelector('[data-reviews-scroller]');
    if (!el) return;

    var jumping = false;
    var dragging = false;
    var didDrag = false;
    var startX = 0;
    var scrollLeft = 0;

    el.scrollLeft = el.scrollWidth / 3;

    el.addEventListener('scroll', function () {
      if (jumping) return;
      var setWidth = el.scrollWidth / 3;
      if (el.scrollLeft < setWidth * 0.25) {
        jumping = true;
        el.scrollLeft += setWidth;
        jumping = false;
      } else if (el.scrollLeft > setWidth * 2 - el.clientWidth * 0.75) {
        jumping = true;
        el.scrollLeft -= setWidth;
        jumping = false;
      }
    });

    el.addEventListener('mousedown', function (e) {
      dragging = true;
      didDrag = false;
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
      el.style.cursor = 'grabbing';
    });
    el.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      e.preventDefault();
      var x = e.pageX - el.offsetLeft;
      if (Math.abs(x - startX) > 6) didDrag = true;
      el.scrollLeft = scrollLeft - (x - startX) * 1.2;
    });
    function endDrag() {
      dragging = false;
      el.style.cursor = 'grab';
    }
    el.addEventListener('mouseup', endDrag);
    el.addEventListener('mouseleave', endDrag);

    /* Modal */
    if (!root) return;
    var modal = root.querySelector('[data-review-modal]');
    if (!modal) return;

    var photoEl = modal.querySelector('[data-review-modal-photo]');
    var nameEl = modal.querySelector('[data-review-modal-name]');
    var dogEl = modal.querySelector('[data-review-modal-dog]');
    var headingEl = modal.querySelector('[data-review-modal-heading]');
    var textEl = modal.querySelector('[data-review-modal-text]');
    var dateEl = modal.querySelector('[data-review-modal-date]');

    function openModal(card) {
      var name = card.getAttribute('data-name') || '';
      var location = card.getAttribute('data-location') || '';
      var dog = card.getAttribute('data-dog') || '';
      var title = card.getAttribute('data-title') || '';
      var text = card.getAttribute('data-text') || '';
      var date = card.getAttribute('data-date') || '';
      var photo = card.getAttribute('data-photo') || '';
      var objectPosition = card.getAttribute('data-object-position') || 'center';

      if (nameEl) nameEl.textContent = name + (location ? ' ' + location : '');
      if (dogEl) dogEl.textContent = dog;
      if (headingEl) headingEl.textContent = title;
      if (textEl) textEl.textContent = text;
      if (dateEl) dateEl.textContent = date;

      if (photoEl) {
        if (photo) {
          photoEl.src = photo;
          photoEl.alt = name;
          photoEl.style.objectPosition = objectPosition;
          photoEl.classList.remove('hidden');
        } else {
          photoEl.removeAttribute('src');
          photoEl.classList.add('hidden');
        }
      }

      modal.classList.remove('hidden');
      modal.classList.add('flex');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.add('hidden');
      modal.classList.remove('flex');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-review-card]').forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (didDrag) {
          e.preventDefault();
          return;
        }
        openModal(card);
      });
    });

    modal.querySelectorAll('[data-review-modal-close], [data-review-modal-backdrop]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.classList.contains('hidden')) closeModal();
    });
  }

  /* ── How it works state cycle ───────────────────────────── */
  function initHowItWorks() {
    var root = document.querySelector('[data-how-it-works]');
    if (!root) return;

    var states = [
      { color: '#4F6F52', title: 'All Clear', body: 'Max is comfortable and safe', temp: '72°F', notifTitle: 'All Clear', notifBody: 'Max is comfortable and safe · 72°F' },
      { color: '#D97706', title: 'Monitoring', body: 'Activity detected, tracking closely', temp: '81°F', notifTitle: 'Heads Up', notifBody: 'Max is active, monitoring closely · 81°F' },
      { color: '#DC2626', title: 'Heat Risk Increasing', body: 'Move Max to shade now', temp: '89°F', notifTitle: 'Heat Alert', notifBody: 'Move Max to shade immediately · 89°F' },
      { color: '#4F6F52', title: 'Safe', body: 'Max is cooling down', temp: '78°F', notifTitle: 'Safe Now', notifBody: 'Max is cooling down. Nice work · 78°F' },
    ];
    var idx = 0;

    function apply() {
      var s = states[idx];
      var circle = root.querySelector('[data-monitor-circle]');
      var temp = root.querySelector('[data-monitor-temp]');
      var title = root.querySelector('[data-monitor-title]');
      var body = root.querySelector('[data-monitor-body]');
      var dot = root.querySelector('[data-notif-dot]');
      var nTitle = root.querySelector('[data-notif-title]');
      var nBody = root.querySelector('[data-notif-body]');
      if (circle) {
        circle.style.backgroundColor = s.color;
        circle.style.boxShadow = '0 10px 30px ' + s.color + '50';
      }
      if (temp) temp.textContent = s.temp;
      if (title) title.textContent = s.title;
      if (body) body.textContent = s.body;
      if (dot) dot.style.backgroundColor = s.color;
      if (nTitle) nTitle.textContent = s.notifTitle;
      if (nBody) nBody.textContent = s.notifBody;
    }

    apply();
    setInterval(function () {
      idx = (idx + 1) % states.length;
      apply();
    }, 4000);
  }

  /* ── Money format helper ────────────────────────────────── */
  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    if (!format) return '$' + amount;
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_with_period_separator\s*\}\}/g, amount);
  }

  /* ── Product page ───────────────────────────────────────── */
  function initProduct() {
    var page = document.querySelector('[data-product-page]');
    if (!page) return;

    var priceCents = parseInt(page.getAttribute('data-price-cents') || '0', 10);
    var moneyFormat = page.getAttribute('data-money-format') || '${{amount}}';

    /* Gallery */
    var mains = page.querySelectorAll('[data-gallery-main]');
    var thumbs = page.querySelectorAll('[data-gallery-thumb]');

    function showImage(index) {
      mains.forEach(function (el) {
        el.classList.toggle('hidden', parseInt(el.getAttribute('data-index'), 10) !== index);
      });
      thumbs.forEach(function (el) {
        var active = parseInt(el.getAttribute('data-index'), 10) === index;
        el.classList.toggle('border-[#4F6F52]', active);
        el.classList.toggle('ring-2', active);
        el.classList.toggle('ring-[#4F6F52]/30', active);
        el.classList.toggle('scale-[1.02]', active);
        el.classList.toggle('border-[#E5E5E7]', !active);
        el.classList.toggle('opacity-75', !active);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showImage(parseInt(thumb.getAttribute('data-index'), 10));
      });
    });

    /* Zoom */
    mains.forEach(function (main) {
      var img = main.querySelector('[data-zoom-img]');
      var hint = main.querySelector('[data-zoom-hint]');
      if (!img) return;
      main.addEventListener('mouseenter', function () {
        if (hint) hint.style.opacity = '0';
      });
      main.addEventListener('mouseleave', function () {
        img.style.transform = 'scale(1)';
        if (hint) hint.style.opacity = '';
      });
      main.addEventListener('mousemove', function (e) {
        var rect = main.getBoundingClientRect();
        var x = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
        var y = Math.max(0, Math.min(100, ((e.clientY - rect.top) / rect.height) * 100));
        img.style.transformOrigin = x + '% ' + y + '%';
        img.style.transform = 'scale(2.4)';
      });
    });

    /* Quantity + totals */
    var qtyInput = page.querySelector('[data-qty-input]');
    var qtyMinus = page.querySelector('[data-qty-minus]');
    var qtyPlus = page.querySelector('[data-qty-plus]');
    var qtyLabel = page.querySelector('[data-qty-label]');
    var lineTotal = page.querySelector('[data-line-total]');
    var orderTotal = page.querySelector('[data-order-total]');
    var ctaLabel = page.querySelector('[data-cta-label]');

    function syncTotals() {
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      qtyInput.value = String(qty);
      if (qtyMinus) qtyMinus.disabled = qty <= 1;
      if (qtyLabel) qtyLabel.textContent = String(qty);
      var total = formatMoney(priceCents * qty, moneyFormat);
      if (lineTotal) lineTotal.textContent = total;
      if (orderTotal) orderTotal.textContent = total;
      if (ctaLabel && !ctaLabel.textContent.trim().toLowerCase().includes('sold')) {
        ctaLabel.textContent = 'Order Now • ' + total;
      }
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', syncTotals);
      qtyInput.addEventListener('input', syncTotals);
    }
    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1));
        syncTotals();
      });
    }
    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        qtyInput.value = String((parseInt(qtyInput.value, 10) || 1) + 1);
        syncTotals();
      });
    }
    syncTotals();

    /* Variant option radios → update hidden id if product JSON present */
    var jsonEl = document.querySelector('[data-product-json]');
    var variantInput = page.querySelector('[data-variant-id]');
    if (jsonEl && variantInput) {
      try {
        var product = JSON.parse(jsonEl.textContent);
        var optionInputs = page.querySelectorAll('[data-option-input]');
        function selectedOptions() {
          var opts = [];
          product.options.forEach(function (name, i) {
            var checked = page.querySelector('input[name="options[' + name + ']"]:checked');
            opts[i] = checked ? checked.value : product.variants[0].options[i];
          });
          return opts;
        }
        function findVariant(opts) {
          return product.variants.find(function (v) {
            return v.options.every(function (o, i) {
              return o === opts[i];
            });
          });
        }
        optionInputs.forEach(function (input) {
          input.addEventListener('change', function () {
            var v = findVariant(selectedOptions());
            if (!v) return;
            variantInput.value = v.id;
            priceCents = v.price;
            page.setAttribute('data-price-cents', String(v.price));
            var unit = page.querySelector('[data-unit-price]');
            if (unit) unit.textContent = formatMoney(v.price, moneyFormat);
            syncTotals();
          });
        });
      } catch (err) {
        /* ignore */
      }
    }
  }

  /* ── Contact form → Formspree ───────────────────────────── */
  function initContactForm() {
    var root = document.querySelector('[data-contact-root]');
    var form = document.querySelector('[data-contact-form]');
    if (!root || !form) return;

    var success = root.querySelector('[data-contact-success]');
    var errorBox = root.querySelector('[data-contact-error]');
    var submitBtn = root.querySelector('[data-contact-submit]');
    var resetBtn = root.querySelector('[data-contact-reset]');
    var subjectHidden = form.querySelector('input[name="_subject"]');
    var subjectInput = form.querySelector('#ContactForm-subject');

    function showError(msg) {
      if (!errorBox) return;
      errorBox.textContent = msg;
      errorBox.classList.remove('hidden');
    }

    function clearError() {
      if (!errorBox) return;
      errorBox.textContent = '';
      errorBox.classList.add('hidden');
    }

    function showSuccess() {
      form.classList.add('hidden');
      if (success) {
        success.classList.remove('hidden');
        success.classList.add('flex');
      }
    }

    function showForm() {
      if (success) {
        success.classList.add('hidden');
        success.classList.remove('flex');
      }
      form.classList.remove('hidden');
      form.reset();
      clearError();
    }

    if (resetBtn) resetBtn.addEventListener('click', showForm);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (subjectHidden && subjectInput && subjectInput.value) {
        subjectHidden.value = 'Furcast contact: ' + subjectInput.value;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending…';
      }

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      })
        .then(function (res) {
          if (res.ok) {
            showSuccess();
            return;
          }
          return res.json().then(function (data) {
            var msg =
              (data && data.errors && data.errors.map(function (err) { return err.message; }).join(' ')) ||
              (data && data.error) ||
              'Something went wrong. Please try again, or email us directly.';
            throw new Error(msg);
          });
        })
        .catch(function (err) {
          showError(err.message || 'Something went wrong. Please try again, or email us directly.');
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Send message';
          }
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initFaq();
    initReviews();
    initHowItWorks();
    initProduct();
    initContactForm();
  });
})();
